export default __webpack_public_path__ + "static/media/index.1baf2544.jpg";